export const COMPLETE_TOUR = "COMPLETE_TOUR";
export const EXECUTE_ACTION = "EXECUTE_ACTION"
export const ACHIEVE = "ACHIEVE"
export const OPEN_ACHIEVEMENT_BANNER = "OPEN_ACHIEVEMENT_BANNER"
export const CLOSE_ACHIEVEMENT_BANNER = "CLOSE_ACHIEVEMENT_BANNER"
export const DATA_LOADED = "DATA_LOADED";
export const SET_UP = "SET_UP"
